import { ICustomerWalletDetailsResponse } from "api/types";
import images from "assets";

import Button from "components/common/Button/Button";
import Divider from "components/common/Divider";
import Text from "components/common/Text/Text";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import { Routes } from "router";
import Block from "screens/Main/Block";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import styled from "styled-components";

interface IProps {
  tenantId: string;
  hasNoInterests?: boolean;
  blockchainWalletDetails: ICustomerWalletDetailsResponse;
  showTabletPurchaseFlow?: boolean;
  showTabletRewardsFlow?: boolean;
  showTabletPromoCodesFlow?: boolean;
}

const SpacedText = styled(Text)`
  margin-top: 6rem;
`;

const MainDashboardMenu = ({
  tenantId,
  hasNoInterests,
  blockchainWalletDetails,
  showTabletPurchaseFlow,
  showTabletRewardsFlow,
  showTabletPromoCodesFlow
}: IProps) => {
  const { goTo } = OnboardingContainer.useContainer();
  const logout = () => goTo({ route: Routes.Home, clearSession: true });
  if (
    !showTabletPurchaseFlow &&
    !showTabletRewardsFlow &&
    !showTabletPromoCodesFlow
  ) {
    return (
      <SpacedText h3 alternate center fullWidth>
        Contact your administrator to add menu options
      </SpacedText>
    );
  }
  return (
    <>
      <SpacedText hero alternate center fullWidth>
        Choose an option
      </SpacedText>
      <Row justify="center">
        {showTabletRewardsFlow && (
          <Col>
            <Link to={Routes.RedeemRewards}>
              <Block>
                <img src={images.rewardsIcon} alt="rewards" />
                <Text h4 alternate center fullWidth>
                  Redeem Rewards
                </Text>
              </Block>
            </Link>
          </Col>
        )}
        {showTabletPurchaseFlow && (
          <Col>
            <Link to={Routes.CompletePurchase}>
              <Block>
                <img src={images.basketIcon} alt="purchase" />
                <Text h4 alternate center fullWidth>
                  Make a purchase
                </Text>
              </Block>
            </Link>
          </Col>
        )}
        {showTabletPromoCodesFlow && (
          <Col>
            <Link to={Routes.PromoCode}>
              <Block>
                <img src={images.hornIcon} alt="promocode" />
                <Text h4 alternate center fullWidth>
                  Use a promo code
                </Text>
              </Block>
            </Link>
          </Col>
        )}
        <Col>
          <Link
            to={{
              pathname: hasNoInterests
                ? Routes.ChangePin
                : Routes.EditInterestSelection,
              state: {
                tenantId,
                walletStatus: blockchainWalletDetails.walletStatus,
                walletDetails: blockchainWalletDetails.walletDetails
              }
            }}
          >
            <Block>
              <img src={images.editProfileIcon} alt="editprofile" />
              <Text h4 alternate center fullWidth>
                Edit Profile
              </Text>
            </Block>
          </Link>
        </Col>
      </Row>
      <Divider transparent />
      <Divider transparent />
      <Row justify="center" align="center" style={{ textAlign: "center" }}>
        <Col>
          <Button onClick={logout} tertiary wider center>
            Log Out
          </Button>
        </Col>
      </Row>
    </>
  );
};
export default MainDashboardMenu;



// WEBPACK FOOTER //
// ./src/screens/Main/MainDashboardMenu/MainDashboardMenu.tsx